import { render, staticRenderFns } from "./Favourites.vue?vue&type=template&id=21cb5c4a&"
import script from "./Favourites.vue?vue&type=script&lang=js&"
export * from "./Favourites.vue?vue&type=script&lang=js&"
import style0 from "./Favourites.vue?vue&type=style&index=0&id=21cb5c4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports